var map = {
	"./ar.json": 4686,
	"./de.json": 9510,
	"./en.json": 4318,
	"./es.json": 5029,
	"./fr.json": 9533,
	"./it.json": 9816,
	"./nl.json": 7647,
	"./pl.json": 1810,
	"./sl.json": 6422,
	"./tr.json": 6059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2072;